import React, { useState, useMemo,useEffect } from "react";
import RightSidebar from "./RightSidebar";
import BottomBar from "./BottomBar";
import StepTabs from "./StepTabs";
import "./TransactionDetail.css";
import { ClientCounterpartyForm } from "./forms/client-counterparty/clientCoutnerparty";
import { Modal } from "./ui/Modal";
import { useClientCounterpartyData } from "../hooks/useClientCounterpartyData";
import { diligenceObservable } from "../observers/deligenceObservable";
import FloatingMessageCenter from "./FloatingMessageCenter";
import AddressUpdateConfirmationModal from "./ui/AddressUpdateConfirmationModal";
import FloatingQueryCenter from "./FloatingQueryCenter";
import ConfirmationModal from "./ui/ConfirmationModal";
import LoaderModal from './Loader';
import { useNavigate } from "react-router-dom";
import ViewModeBanner from "./ui/ViewModeBanner";
const ClientCounterparty = ({isReport}) => {

  
  
  const {
    isSelectorReadOnly,
    searchParams,
    compliantLetter,
    modalMessage,
    hasUnsavedChanges,
    modalHeading,
    step,
    transactionId,
    transactionType,
    isModalOpen,
    isReadOnly,
    setIsReadOnly,
    formData,
    
    
    setmodalOpen,
    selectedOption,
    regulatoryBodies,
    companyTypes,
    exchanges,
    isRegulatoryListed,
    isBillingEntityListed,
    existingEntity,
    countries,
    setIsModalOpen,
    sendMail,
    handleChange,
    handleRegulatoryChange,
    handleBillingEntityChange,
    handleentityChange,
    handleMoneyChange,
    handleCountryChange,
    handleUpdate,
    handleNext,
    handleEntityChanged,
    onValidate,
    setModalOpen,
    modalOpen,
    showAddressModal,
    validationResult,
    setShowAddressModal,
    pendingUpdatedData,
    isLoading,
    loadingMessage,
  } = useClientCounterpartyData();

  // Single source of truth for the lock: the status on screen. Reading the
  // localStorage copy left a validated page rendering unlocked until a reload.
  const checkStatus = formData.entityStatus === "Validated";

  const [activeTab, setActiveTab] = useState("step3");
  const isEntityIdMissing = useMemo(() => {
    // Check if entityId is missing, empty, None, or only whitespace
    const entityId = formData.entityId;

    // Check for various invalid states
    const isMissing =
      !entityId ||                                              // null, undefined, false, 0
      entityId === "None" ||                                    // string "None"
      (typeof entityId === 'string' && entityId.trim() === "") || // empty string
      (typeof entityId === 'object' && Object.keys(entityId).length === 0); // empty object

    console.log("🔍 Entity ID Check:", { entityId, type: typeof entityId, isMissing });
    return isMissing;
  } ,[formData.entityId])

  useEffect(() => {
    console.log("🚦 Next Button State:", {
      isEntityIdMissing,
      entityId: formData.entityId,
      buttonShouldBeDisabled: isEntityIdMissing
    });
  }, [isEntityIdMissing, formData.entityId]);

  useEffect(() => {
    const isReadOnlyFromURL = searchParams.get("readonly") === "true";
    const isViewMode = searchParams.get("view") === "true";
    const isEditMode = searchParams.get("edit") === "true";
    if (isReadOnlyFromURL || isViewMode || checkStatus) {
      setIsReadOnly(true);
    } else {
      setIsReadOnly(false);
    }
  }, [checkStatus, searchParams]);
    const navigate = useNavigate();
  return (
    <>
      {/* Right Sidebar */}
     

      <div className={!isReport ? "transaction-detail" : ""}>
        {!isReport && <StepTabs
          searchParams={searchParams}
          hasUnsavedChanges={hasUnsavedChanges}
          activeTab={activeTab}
          isEntityIdMissing={isEntityIdMissing}
          onTabChange={(tabId) => setActiveTab(tabId)}
        />}{" "}
        {/* Display step tabs at the top */}
        <ViewModeBanner
          isReadOnly={isReadOnly}
          status={formData?.entityStatus}
        />
        {/* Main Form */}
        <div className="form-section">
        <ClientCounterpartyForm
          isReport={isReport}
          isSelectorReadOnly={isSelectorReadOnly}
          formData={formData}
          step={step}
          existingEntity={existingEntity}
          companyType={companyTypes}
          transactionId={transactionId}
          transactionType={transactionType}
          isRegulatoryListed={isRegulatoryListed}
          isBillingEntityListed={isBillingEntityListed}
          isReadOnly={isReadOnly || isReport}
          countries={countries}
          regulatoryBodies={regulatoryBodies}
          exchanges={exchanges}
          selectedOption={selectedOption}
          sendMail={sendMail}
          showModal={isModalOpen}
          setShowModal={setModalOpen}
          modalMessage={modalMessage}
          setModalOpen={setModalOpen}
          handleChange={handleChange}
          handleBillingEntityChange={handleBillingEntityChange}
          handleCountryChange={handleCountryChange}
          handleEntityChanged={handleEntityChanged}
          handleMoneyChange={handleMoneyChange}
          handleRegulatoryChange={handleRegulatoryChange}
          handleentityChange={handleentityChange}
          handleUpdate={handleUpdate}
        />
        {!isReport && <RightSidebar
        compliantLetter={formData.compliantLetter}
        clientformData={formData}
        RegulatoryListed={formData.isRegulatoryListed}
        BillingRecognized={formData.isBillingRecognized}
        landRegisterCopy={formData.landRegisterCopy}
      />}
      </div>
 
      </div>
      {!isReport && <BottomBar
        buttons={[
          { label: "Save", onClick: handleUpdate, skipConfirmation: true, disabled : checkStatus }, // ✅ No popup
          // { label: "Save", onClick: handleUpdate },
          { label: "Validate & Lock", onClick: onValidate ,disabled : checkStatus },
          {
      label: "Back",
      onClick: () => navigate(`/property-info?${searchParams.toString()}`),
      style: {},
      title: "Go back",
      disabled: false,
    },
          {
            label: "Next",
            onClick: handleNext,
            disabled: isEntityIdMissing,
            title: isEntityIdMissing ? "Entity ID is required to proceed" : "Go to next section"
          }, // Disable Next if entityId is missing
        ]}
      />}
     {isModalOpen && (
          <Modal modalHeading={modalHeading} modalMessage={modalMessage} onClick={() => setIsModalOpen(false)} />
        )}
<ConfirmationModal
              isOpen={modalOpen}
              heading= {modalHeading}
              message={modalMessage}
              onClose={() => setModalOpen(false)}
            />
    <LoaderModal isOpen={isLoading} message={loadingMessage} />
     {/* Address Update Confirmation Modal */}
      {(modalOpen || showAddressModal) && (
      <Modal
        modalHeading={modalHeading}
        modalMessage={
          showAddressModal && validationResult ? (
            <AddressUpdateConfirmationModal
            formData={formData}
            updatedData={pendingUpdatedData}
            onContinue={validationResult.handleContinue}
            onDiscard={validationResult.handleDiscard}
            />
          ) : (
            modalMessage
          )
        }
        onClick={() => {
          if (modalOpen) setModalOpen(false);
          if (showAddressModal) setShowAddressModal(false);
        }}
      />
      )}
<FloatingQueryCenter />
    </>
  );
};

export default ClientCounterparty;
